// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_nm-5";
export var filledCircle = "_nm-4";
export var historyEntry = "_nm-3";
export var messageSideLeft = "_nm-1";
export var messageSideRight = "_nm-2";
export var orderTrackingCarouselWrapper = "_nm-6";
export var orderTrackingInfoContainer = "_nm-0";